import React, { ReactElement } from 'react'
import { LanguageMyReportList, LanguagePrompt } from '../../../../i18n'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
// Commons imports.

/**
 * Inline message for move to bin prompt.
 *
 */
const PromptMoveToBinMessage: React.FC = (): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle('LanguagePrompt')
    language.loadBundle('LanguageMyReportList')

    return (
        <>
            <p>{language?.get(LanguagePrompt.AreYouSureDelete)}</p>
            <p className='padding-top'>{language?.get(LanguageMyReportList.ReportlistThirtydaysremaining)}</p>
        </>
    )
}

export default PromptMoveToBinMessage
